// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowNarrowUpIcon from "@/assets/icons/arrow-narrow-up.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowNarrowUpIconProps = Omit<IconProps, "name">;

export function ArrowNarrowUpIcon(props: ArrowNarrowUpIconProps): React.ReactNode {
  return <Icon name={arrowNarrowUpIcon} {...props} />;
}
